  $(function(){
    $('#engraving_typeface').selectReplace().closest('.selector-wrapper').addClass('has-pretty-select');
  });
  $("[data-custom-message]").on("change keyup",function(e){
    $(".thumbnails .thumbnail:last-child").trigger("click");
    if($("#engraving-overlay").length==0) {
      $(".main-img-link").append($("<div class='engraving-centrepoint' id='engraving-overlay'><div class='engraving-overlay'><p>Your Custom</p><p>Message</p></div></div>"));
      $(".product-gallery .disclaimer").show();
    }
    $("#engraving-overlay p").eq(0).text($("#engraving_line_1").val());
    $("#engraving-overlay p").eq(1).text($("#engraving_line_2").val());
    var font_choice = $("#engraving_typeface").val();
    var selected_font = "inherit";
    $("#engraving-overlay").removeClass("script");
    if(font_choice=="Script") {
      selected_font = "'Times New Roman',serif";
      $("#engraving-overlay").addClass("script");
    }
//     $("#engraving-overlay").css({"font-family":selected_font});
  });
